import React, { useMemo } from "react";
import urls from "utils/urls";
import styles from "./styles.module.scss";

const Brands: React.FC = () => {
  const brands = useMemo(
    () => [
      urls.images("brands/brand1.png"),
      urls.images("brands/brand2.png"),
      urls.images("brands/brand3.png"),
      urls.images("brands/brand4.png"),
      urls.images("brands/brand5.png"),
      urls.images("brands/brand6.png"),
      urls.images("brands/brand7.png"),
    ],
    []
  );

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {brands.map((image) => (
          <div
            className={styles.image}
            key={image}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}

        {brands.map((image) => (
          <div
            className={styles.image}
            key={image}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>
      <div className={styles.content}>
        {brands.map((image) => (
          <div
            className={styles.image}
            key={image}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}

        {brands.map((image) => (
          <div
            className={styles.image}
            key={image}
            style={{ backgroundImage: `url(${image})` }}
          />
        ))}
      </div>
    </div>
  );
};

export default Brands;
